import React, { useState, useEffect } from "react";
import { useLocation, useLoaderData } from "react-router-dom";
import { IoMdSearch } from "react-icons/io";
import { FiMenu } from "react-icons/fi";
import { IoNotificationsOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import styles from "./LayoutHeader.module.scss";
import { toggleSidebar } from "@/widgets/LayoutSidebar/model/slice";
import { toggleProfileSidebar } from "@/widgets/ProfileSidebar/model/slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWorkspaceNameFromUrl } from "@/entities/WorkSpace/api/getWorkspaceId";
import axios from "@/shared/api/axios";
import { setPrimaryCompany } from "@/widgets/LayoutHeader/model/slice";
import { RootState } from "@/app/appStore";
import { fetchWorkspaceData } from "@/widgets/LayoutHeader/model/slice";

interface WorkspaceData {
  korName: string;
  bizNumber: string;
}

export const LayoutHeader = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleProfileSidebar = () => {
    dispatch(toggleProfileSidebar());
  };

  // 랜딩 페이지 헤더
  const LandingHeader = () => (
    <div className={styles.layoutHeader}>
      <div className={styles.headerContent}>
        <div className={styles.logoWrapper}>
          <img src="/logo2.png" alt="Xadom 로고" className={styles.logo} onClick={() => navigate("/")} />
        </div>
        <div className={styles.headerActions}>
          <button 
            className={styles.authButton}
            onClick={() => navigate("/login")}
          >
            로그인
          </button>
          <button 
            className={`${styles.authButton} ${styles.primaryButton}`}
            onClick={() => navigate("/signup")}
          >
            회원가입
          </button>
        </div>
      </div>
    </div>
  );

  // 로그인 페이지 헤더
  const LoginHeader = () => (
    <div className={styles.layoutHeader}>
      <div className={styles.headerContent}>
        <div className={styles.logoWrapper}>
          <img src="/logo2.png" alt="Xadom 로고" className={styles.logo} onClick={() => navigate("/")} />
        </div>
        <div className={styles.headerActions}>
          <button 
            className={`${styles.authButton} ${styles.primaryButton}`}
            onClick={() => navigate("/signup")}
          >
            회원가입
          </button>
        </div>
      </div>
    </div>
  );

  // 회원가입 페이지 헤더
  const SignupHeader = () => (
    <div className={styles.layoutHeader}>
      <div className={styles.headerContent}>
        <div className={styles.logoWrapper}>
          <img src="/logo2.png" alt="Xadom 로고" className={styles.logo} onClick={() => navigate("/")} />
        </div>
        <div className={styles.headerActions}>
          <button 
            className={`${styles.authButton} ${styles.primaryButton}`}
            onClick={() => navigate("/login")}
          >
            로그인
          </button>
        </div>
      </div>
    </div>
  );

  // 인증된 사용자 헤더
  const AuthenticatedHeader = () => {
    const { workspaceData } = useSelector((state: RootState) => state.layoutHeader);
    const loaderData = useLoaderData() as { workspaceData?: any } | null;

    useEffect(() => {
      // 먼저 loader에서 가져온 데이터가 있는지 확인
      if (loaderData?.workspaceData && !workspaceData) {
        // loader 데이터를 Redux store에 저장
        dispatch(setPrimaryCompany(loaderData.workspaceData));
        return;
      }
      
      // loader 데이터도 없고 store에도 없을 때만 API 호출
      if (!workspaceData || (!workspaceData.korName && !workspaceData.bizNumber)) {
        dispatch(fetchWorkspaceData());
      }
    }, [dispatch, workspaceData, loaderData]);

    return (
      <div className={styles.layoutHeader}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <button 
              className={styles.menuButton}
              onClick={handleToggleSidebar}
            >
              <FiMenu size={24} />
            </button>
            
            <div className={styles.divider} />
            
            <div className={styles.workspaceDisplay}>
              <div className={styles.xIcon}>
                <img src="/X.png" alt="X" />
              </div>
              <span className={styles.workspaceName}>{getWorkspaceNameFromUrl()}</span>
            </div>
            
            <div className={styles.divider} />
            
            <div className={styles.companyDisplay}>
              {workspaceData?.korName && (
                <span className={styles.companyName}>{workspaceData.korName}</span>
              )}
              {workspaceData?.bizNumber && (
                <span className={styles.businessNumber}>{workspaceData.bizNumber}</span>
              )}
            </div>
          </div>
          
          <div className={styles.headerRight}>
            <div className={styles.searchContainer}>
              <IoMdSearch className={styles.searchIcon} />
              <input
                type="text"
                placeholder="/ 눌러검색"
                className={styles.searchInput}
              />
            </div>
            
            <div className={styles.headerActions}>
              <button className={styles.iconButton}>
                <IoNotificationsOutline size={20} />
              </button>
              
              <button className={styles.iconButton}>
                <IoSettingsOutline size={20} />
              </button>
              
              <div 
                className={styles.profileButton}
                onClick={handleProfileSidebar}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 현재 경로에 따라 적절한 헤더 렌더링
  const renderHeader = () => {
    var rootUri = location.pathname.split('/')[1];

    switch (rootUri) {
      case "login":
        return <LoginHeader />;
      case "signup":
        return <SignupHeader />;
      case "":
        return <LandingHeader />;
      default:
        return <AuthenticatedHeader />;
    }
  };

  return <header>{renderHeader()}</header>;
};
